// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607301616/js/" + chunkId + "." + {"44":"2b04e3ed","225":"70136eb2","481":"ad2ff40c","486":"1818bbb7","770":"7538f688"}[chunkId] + ".0.08836532283002496.chunk.js";
};